import { motion } from "framer-motion"

const IconNext = ({ className, size = 32, fill = "currentColor", ...animations }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <motion.path
      {...animations}
      d="M8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"
      fill={fill}
      stoke="none"
      fillRule="evenodd"
    />
  </svg>
)

export default IconNext
